// Helper function to get rating based on percentage and score configuration
interface ScoreConfig {
  id: string;
  color: string;
  rating: string;
  logic: string;
  value: string | number[];
}

export const getMatchingScoreConfig = (
  percentage: number,
  scoreConfig: ScoreConfig[] = [],
): ScoreConfig | undefined => {
  // Handle null or undefined scoreConfig
  if (!scoreConfig || !Array.isArray(scoreConfig)) {
    return undefined;
  }

  for (const config of scoreConfig) {
    const { logic, value } = config;

    switch (logic) {
      case 'eq':
        if (percentage === Number(value)) {
          return config;
        }
        break;
      case 'gt':
        if (percentage > Number(value)) {
          return config;
        }
        break;
      case 'gte':
        if (percentage >= Number(value)) {
          return config;
        }
        break;
      case 'lt':
        if (percentage < Number(value)) {
          return config;
        }
        break;
      case 'lte':
        if (percentage <= Number(value)) {
          return config;
        }
        break;
      case 'btw':
        if (Array.isArray(value) && value.length === 2) {
          const [min, max] = value.map(Number);
          if (percentage >= min && percentage <= max) {
            return config;
          }
        }
        break;
      default:
        // Handle unknown logic types gracefully
        break;
    }
  }

  // Return undefined if no matching configuration is found
  return undefined;
};

export const COLORING_SCHEME = {
  '#4CAF50': {
    secondaryColor: '#E8F5E9',
    borderColor: '#C8E6C9',
    labelColor: '#2E7D32',
  },
  '#29B6F6': {
    secondaryColor: '#E1F5FE',
    borderColor: '#B3E5FC',
    labelColor: '#0277BD',
  },
  '#6868FE': {
    secondaryColor: '#EBEAFF',
    borderColor: '#CCCBFF',
    labelColor: '#4E48FA',
  },
  '#8D6E63': {
    secondaryColor: '#EFEBE9',
    borderColor: '#D7CCC8',
    labelColor: '#5D4037',
  },
  '#D4E157': {
    secondaryColor: '#FBFCEE',
    borderColor: '#DCE775',
    labelColor: '#495000',
  },
  '#EC407A': {
    secondaryColor: '#FDEDF2',
    borderColor: '#F8BBD0',
    labelColor: '#C2185B',
  },
  '#FF7043': {
    secondaryColor: '#FBEBE9',
    borderColor: '#FFCCBC',
    labelColor: '#E64A19',
  },
  '#FFB300': {
    secondaryColor: '#FFF5E0',
    borderColor: '#FFE9A3',
    labelColor: '#513D00',
  },
  '#EF5350': {
    secondaryColor: '#FFEBEE',
    borderColor: '#FFCDD2',
    labelColor: '#D32F2F',
  },
  '#78909C': {
    secondaryColor: '#F3F5F6',
    borderColor: '#CFD8DC',
    labelColor: '#263238',
  },
  '#1f1e1ee0': {
    secondaryColor: '#1f1e1e21',
    borderColor: '#1f1e1e21',
    labelColor: '#1f1e1ee0',
  },
};
